import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { map, Observable, startWith } from 'rxjs';
import { CuisinesService } from 'src/app/features/configrations/cuisines/services/Cuisines.service';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import { CustomValidator } from 'src/app/helpers/custom.validator';
import { Patterns } from 'src/app/helpers/patterns';
import { Lookup } from 'src/app/models/Lookup';
import { LookupsService } from 'src/app/services/lookups.service';
import Swal from 'sweetalert2';
import { RestaurantDetails, RestaurantForm, RestaurantType } from '../../models/List.Restaurant';
import { RestaurantService } from '../../services/Restaurant.service';

export interface DialogData {
  record: RestaurantDetails,
  id: any
}
@Component({
  selector: 'app-restaurant-form-dialog',
  templateUrl: './restaurant-form-dialog.component.html'
})
export class RestaurantFormDialogComponent extends DirtyComponent implements OnInit {
  loading = false;
  dataLoading = false
  isSubmitted = false;
  isUpdate = false;
  details!: RestaurantDetails;;

  override formGroup!: FormGroup;

  cuisinesLoading = false;
  cuisinCtr = new FormControl<string | Lookup>('');
  cuisines: Lookup[] = [];
  filteredCuisines!: Observable<Lookup[]>;
  selectedCuisines: Lookup[] = [];

  countries: Lookup[] = [];
  cities: Lookup[] = [];
  countryLoading = false;
  cityLoading = false;

  // image file
  logo: any;
  logoSrc!: string;
  // banner file
  banner: any;
  bannerSrc!: string;

  maxFileSize = 1;
  fileTypeError = false;
  fileSizeError = false;

  maxBannerSize = 2;
  bannerTypeError = false;
  bannerSizeError = false;


  selectedCountry: any;

  constructor(
    override dialogRef: MatDialogRef<RestaurantFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    translate: TranslateService,
    private _formBuilder: FormBuilder,
    private service: RestaurantService,
    private lookupsService: LookupsService,
    private cuisineservice: CuisinesService,
  ) { super(translate); }

  ngOnInit(): void {
    if (this.data.id) {
      this.getDetails();
    } else {
      this.details = this.data.record
    }
    this.buildForm();
    this.getCountries();
    this.getCuisines();
  }

  getDetails() {
    this.dataLoading = true;
    this.service.GetDetails(this.data.id).subscribe((res) => {
      this.details = res
      this.bindDataToUpdate();
      this.dataLoading = false;
    })
  }

  getCountries() {
    this.countryLoading = true;
    this.lookupsService.getCountries().subscribe(
      data => {
        this.countries = data as [];
        this.countryLoading = false;
      }, err => {
        console.error(err);
      });
  }
  cityParentChange(countryId: number) {
    this.formGroup.controls['cityId'].setValue(null);
    this.getCities(countryId);
  }
  getCities(countryId: number) {
    this.cityLoading = true;
    this.lookupsService.getCities(countryId).subscribe(
      data => {
        this.cities = data as [];
        this.cityLoading = false;
      }, err => {
        console.error(err);
      });
  }

  // Cuisines search field
  getCuisines() {
    this.cuisinesLoading = true;
    this.cuisineservice.GetCuisines().subscribe(
      data => {
        this.cuisinesLoading = false;
        this.cuisines = data as [];
        this.initCuisinesFiltiration();
      }, err => {
        console.error(err);
      });
  }
  initCuisinesFiltiration() {
    this.filteredCuisines = this.cuisinCtr.valueChanges.pipe(
      startWith(''),
      map(value => {
        const name = typeof value === 'string' ? value : value?.name;
        return name ? this._filter(name as string) : this.cuisines.slice();
      }),
    );
  }
  displayFn(item: Lookup): string {
    return item && item.name ? item.name : '';
  }
  private _filter(name: string): Lookup[] {
    const filterValue = name.toLowerCase();
    return this.cuisines.filter(item => item.name.toLowerCase().includes(filterValue));
  }
  cuisinSelected(value: Lookup) {
    if (!this.isSelected(value)) {
      this.selectedCuisines.push(value);
    } else {
      let index = this.selectedCuisines.findIndex(item => item.id === value.id)
      if (index >= 0) {
        this.selectedCuisines.splice(index, 1);
      }
    }
    this.cuisinCtr.setValue('');
  }
  removeCuisin(i: number) {
    this.selectedCuisines.splice(i, 1);
  }
  isSelected(v: Lookup) {
    return this.selectedCuisines.some(item => item.id === v.id)
  }
  // End Cuisines search field

  buildForm() {
    this.formGroup = this._formBuilder.group({
      restaurantType: [null],
      parintId: [null],
      title_EN: [null, [
        CustomValidator.noWhiteSpace,
        // Validators.pattern(Patterns.enTxt),
        Validators.maxLength(50),
      ]],
      title_AR: [null, [
        CustomValidator.noWhiteSpace,
        Validators.maxLength(50),
        // Validators.pattern(Patterns.arTxt)
      ]],
      mail: [null, [
        Validators.required,
        Validators.maxLength(320),
        Validators.pattern(Patterns.email)
      ]],
      phone: [null, [Validators.required]],
      website: [null, [Validators.pattern(Patterns.website)]],
      map: [null],
      countryId: [null, Validators.required],
      cityId: [null, Validators.required],
      streetEn: [null, CustomValidator.noWhiteSpace],
      streetAr: [null, CustomValidator.noWhiteSpace],
      latitude: [null, [CustomValidator.noWhiteSpace, Validators.pattern(Patterns.float)]],
      longitude: [null, [CustomValidator.noWhiteSpace, Validators.pattern(Patterns.float)]],
      vatNumber: [null, CustomValidator.noWhiteSpace],
      shortName: [null, CustomValidator.noWhiteSpace],
      facebook: [null],
      twitter: [null],
      instagram: [null],
      snapchat: [null],
      tiktok: [null],
      whatsapp: [null, [Validators.pattern(Patterns.phoneNumber)]],
      youtube: [null],
    });
    if (this.details) {
      this.bindDataToUpdate();
    }
  }
  bindDataToUpdate() {
    this.formGroup.patchValue(this.details);
    if (this.details.parintId) {
      this.formGroup.controls['restaurantType'].setValue(RestaurantType.Branch);
      this.formGroup.controls['parintId'].setValue(this.details.parintId);
    } else {
      this.formGroup.controls['restaurantType'].setValue(RestaurantType.Main);
      this.formGroup.controls['parintId'].setValue(0);
    }
    this.getCities(this.details.countryId);
    this.selectedCuisines = this.details.restaurantCuisine.map(item => item.cuisine)
    this.logoSrc = this.details.icon;
    this.bannerSrc = this.details.banner;

    this.selectedCountry = this.details.phoneflag
  }
  hasError(formGroup: FormGroup, controlName: string, errorName: string) {
    return formGroup.controls[controlName].hasError(errorName);
  }


  // File preview with validation
  changeFileListener($event: any, index: any): void {
    const file: File = $event.target.files[0];
    if (file && this.validateFile(file, index)) {

      if (index == 0) {
        this.banner = file;
        this.readThis(file, 0);

      } else {
        this.logo = file;
        this.readThis(file, 1);

      }
    } else {
      if (index == 0) {
        this.bannerSrc = '';
        this.banner = undefined;

      } else {
        this.logoSrc = '';
        this.logo = undefined;
      }
    }
  }
  readThis(file: File, index: any): void {
    const myReader: FileReader = new FileReader();
    myReader.readAsDataURL(file);
    myReader.onloadend = (e) => {
      if (index == 0) {
        this.bannerSrc = myReader.result as string;

      } else {
        this.logoSrc = myReader.result as string;
      }
    };
  }
  validateFile(file: File, index: any): any {
    if (this.fileType(file.name)) {
      if (index == 0) {
        this.bannerTypeError = false;
        if ((file.size / (1024 * 1024)) <= this.maxBannerSize) {
          this.bannerSizeError = false;
        } else {
          this.bannerSizeError = true;
          return false;
        }
      } else {
        this.fileTypeError = false;
        if ((file.size / (1024 * 1024)) <= this.maxFileSize) {
          this.fileSizeError = false;
        } else {
          this.fileSizeError = true;
          return false;
        }
      }
    } else {
      if (index == 0) {
        this.bannerTypeError = true;
        return false;
      } else {
        this.fileTypeError = true;
        return false;
      }
    }
    return true;
  }
  fileType(fileName: string): any {
    const extension = fileName.split('.')?.pop()?.toLowerCase();
    switch (extension) {
      case 'jpeg':
      case 'jpg':
        return 'jpg';
      case 'png':
        return 'png';
      default:
        return false;
    }
  }


  checkCuisines() {
    if (!this.selectedCuisines.length) {
      this.cuisinCtr.setErrors({ required: true });
    } else {
      this.cuisinCtr.setErrors(null);
    }
    this.cuisinCtr.markAsTouched()
  }

  saveRecord() {
    this.isSubmitted = true;
    this.checkCuisines();
    this.formGroup.markAllAsTouched();

    if (this.formGroup.valid && this.logoSrc && this.bannerSrc && this.selectedCuisines.length) {
      if (this.formGroup.controls['countryId'].value !== this.details.countryId) {
        Swal.fire({
          title: this.translate.instant('swalMsg.Areyousure'),
          text: this.translate.instant('restaurant.We will reset vat settings for all menu items for the default vat'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.translate.instant('swalMsg.Yes'),
          cancelButtonText: this.translate.instant('swalMsg.No')
        }).then((result) => {
          if (result.value) {
            this.editRest();
          }
        });
      } else {
        this.editRest();
      }
    }
  }
  editRest() {
    this.loading = true;
    let data: RestaurantForm = this.formGroup.value;
    data.id = this.details.id;
    data.cuisines = this.selectedCuisines.map((x: any) => x.id);
    data.phoneflag = this.formGroup.controls['phone'].value.countryCode
    data.phoneCode = this.formGroup.controls['phone'].value.dialCode
    data.phone = this.formGroup.controls['phone'].value.number

    this.service.saveRecord(data, this.logo, this.banner).subscribe(() => {
      this.loading = false;
      Swal.fire({
        title: this.translate.instant('swalMsg.Success'),
        text: this.translate.instant('swalMsg.updatedsuccessfully'),
        icon: 'success',
        confirmButtonText: this.translate.instant('swalMsg.Ok')
      });
      this.dialogRef.close(true);
    }, error => {
      this.loading = false;
      Swal.fire({
        title: this.translate.instant('swalMsg.Failed'),
        text: error.detail,
        icon: 'error',
        confirmButtonText: this.translate.instant('swalMsg.Ok'),
      });
    });
  }
}
